import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, House, RefreshCw } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Gateway console render failed", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error-page">
        <div className="fatal-error-panel">
          <AlertTriangle size={24} />
          <div>
            <h1>页面暂时无法显示</h1>
            <p>页面数据存在异常，已阻止错误继续扩散。可以重新加载，或返回运行概览。</p>
          </div>
          <div className="fatal-error-actions">
            <button type="button" className="secondary-button" onClick={() => window.location.assign("/manage/overview")}><House size={16} />返回概览</button>
            <button type="button" className="primary-button" onClick={() => window.location.reload()}><RefreshCw size={16} />重新加载</button>
          </div>
        </div>
      </main>
    );
  }
}
